export default __webpack_public_path__ + "static/media/printer.60156c52.svg";